import { Skeleton } from '@mantine/core';

export const EventListLoader = () => {
  return (
    <>
      <Skeleton height={20} w="80%" />
      <Skeleton height={100} mt={8} w="95%" />
      <Skeleton height={100} mt={8} w="95%" />
      <Skeleton height={100} mt={8} w="95%" />
    </>
  );
};
